import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Requires text or embedded media in Jodit HTML without modifying the value, e.g. content: ['',
 * requiredJoditContentValidator].
 */
export function requiredJoditContentValidator(control: AbstractControl): ValidationErrors | null {
  const html = String(control.value ?? '');
  if (/<(img|video|audio|iframe|object|embed|hr)\b/i.test(html)) {
    return null;
  }

  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#xa0;|&#8203;|\u200b/gi, '')
    .trim();
  return text ? null : { required: true };
}
